import { mmFetchWithResponse } from './mmFetchWithResponse';

const qualityApi = {
    getCCOF: async (facilityID) => {
        const url = `api/quality/v1/ccof?facilityID=${facilityID}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },
    getDirectedRecPhase3Enabled: async (facilityID) => {
        const url = `api/quality/v3/receiving/phase3Enabled/${facilityID}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },
    getPendingRejections: async (facilityID) => {
        const url = `api/quality/v3/receiving/pendingRejections/${facilityID}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },
    getPendingIssues: async (facilityID) => {
        const url = `api/quality/v3/receiving/pendingIssues/${facilityID}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },

    didNotArrive: async (poMapID) =>
        mmFetchWithResponse(`api/quality/v3/receiving/didNotArrive/${poMapID}`, {
            method: 'POST',
        }),

    acceptRejection: async (poMapID) => {
        const url = `api/quality/v3/receiving/acceptRejection/${poMapID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
        });
    },
    denyRejection: async (poMapID) => {
        const url = `api/quality/v3/receiving/denyRejection/${poMapID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
        });
    },
    recordCasesCounted: async (poMapID, casesCounted) => {
        const uri = `api/quality/v3/receiving/record/${poMapID}/casesCounted`;
        return mmFetchWithResponse(uri, {
            method: 'POST',
            body: JSON.stringify({
                casesCounted,
            }),
        });
    },
    recordCaseUnitCountValue: async (poMapID, caseIdx, value) => {
        const uri = `api/quality/v3/receiving/record/${poMapID}/caseUnitCount`;
        return mmFetchWithResponse(uri, {
            method: 'POST',
            body: JSON.stringify({
                value,
                caseIdx,
            }),
        });
    },
    recordCaaseUnitWeightValue: async (poMapID, caseIdx, weightIdx, value) => {
        const uri = `api/quality/v3/receiving/record/${poMapID}/caseUnitWeight`;
        return mmFetchWithResponse(uri, {
            method: 'POST',
            body: JSON.stringify({
                value,
                caseIdx,
                weightIdx,
            }),
        });
    },

    resetQCModule: async (purchaseOrderMapId, moduleName) => {
        const uri = `api/quality/v1/receiving/items/${purchaseOrderMapId}/modules/${moduleName}/desktop-reset`;
        return mmFetchWithResponse(uri, {
            method: 'POST',
        });
    },

    getQualityControlTasks: async (type, facilityID) => {
        const url = `api/inventory/v1/task/qc?type=${type}&facilityID=${facilityID}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },
    getQualityIssueCodes: async () => {
        const url = `api/quality/v2/receiving/issueCodes`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },
    getQualityPOs: async (facilityID) => {
        const url = `api/quality/v1/receiving/purchaseOrders?facilityID=${facilityID}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },
    getQualityPODetails: async (poID) => {
        const url = `api/quality/v1/receiving?poID=${poID}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },
    recordPalletsInspected: async (poMapID, palletsInspected, issueLevel) => {
        const uri = `api/quality/v2/receiving/record/palletsInspected/${poMapID}`;
        return mmFetchWithResponse(uri, {
            method: 'POST',
            body: JSON.stringify({
                palletsInspected,
                issueLevel,
            }),
        });
    },
    recordCasesInspected: async (poMapID, casesInspected, issueLevel) => {
        const uri = `api/quality/v2/receiving/record/casesInspected/${poMapID}`;
        return mmFetchWithResponse(uri, {
            method: 'POST',
            body: JSON.stringify({
                casesInspected,
                issueLevel,
            }),
        });
    },
    recordQualityUnitInspection: async (poMapID, sendParams) => {
        const uri = `api/quality/v3/receiving/unitInspection/${poMapID}`;
        return mmFetchWithResponse(uri, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
    },
    recordQualityReceiving: async (poMapID, sendParams) => {
        const url = `api/quality/v1/receiving/${poMapID}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    getQualityPODetailsV2: async (poID, isPackaging) => {
        const url = `api/quality/v2/receiving?poID=${poID}&isPackaging=${isPackaging}`;
        return mmFetchWithResponse(url, {
            method: 'GET',
        });
    },
    recordQualityReceivingV2: async (poMapID, sendParams) => {
        const url = `api/quality/v2/receiving/record/${poMapID}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    recordQualityReceivingCompleteV2: async (poMapID) => {
        const url = `api/quality/v2/receiving/complete/${poMapID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({}),
        });
    },
    recordQualityReceivingIssueV2: async (qcrExternalIssueID, sendParams, poMapID, issueLevel) => {
        const url = `api/quality/v2/receiving/issue/${poMapID}/${qcrExternalIssueID}`;
        const params = { ...sendParams, issueLevel };
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(params),
        });
    },
    createNewIssueV2: async (poMapID, issueLevel) => {
        const url = `api/quality/v2/receiving/create/${poMapID}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({
                issueLevel,
            }),
        });
    },
    deleteIssueV2: async (issueID, poMapID) => {
        const url = `api/quality/v2/receiving/delete/${poMapID}/${issueID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
        });
    },
    undoRejection: async (poMapID) => {
        const url = `api/quality/v3/receiving/undoRejection/${poMapID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
        });
    },
};

export { qualityApi };
